import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const toggledSlice = createSlice({
    name: "toggle",
    initialState: { value: "toggled" },
    reducers: {
        updateToggle: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

export const { updateToggle } = toggledSlice.actions;
export default toggledSlice.reducer;
